const KacitOverview=()=>{
    return (
       <section className="container mx-auto py-10 px-4 flex items-center justify-center">
        <img src="/images/about/kacit-overview.jpg" alt="" className="h-80 w-100 my-10" />
       </section>
    )
}

export default KacitOverview